/* eslint-disable @typescript-eslint/no-explicit-any */
import {useState} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import {Typography, Box, Link} from '@mui/material';
import Divider from '@jobseeker/lotus/components/Divider';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';

import type {AdElement} from '../../types';

const LearnGrow = ({slot, label}: AdElement) => {
  const [learnGrow, setLearnGrow] = useState([]);

  useLoadAds(slot, setLearnGrow, true);

  return (
    <Box sx={{mt: 5}}>
      <Typography
        component={'span'}
        fontSize={18}
        fontWeight={600}
        color="gray.dark"
      >
        {label}
      </Typography>
      <Divider
        sx={{
          margin: '10px 0 !important',
          border: '0.5px solid #ddd !important',
        }}
      />
      {learnGrow?.map((adObj: any, index) => (
        <Box key={`learnngrow-ads-${index}`}>
          <Box sx={{width: '100%', display: 'grid'}}>
            <Box sx={{display: 'flex', marginTop: '5px'}}>
              <Box sx={{pr: 3}}>
                <Image
                  src={adObj.imageUrl || adObj['Image Url']}
                  alt={adObj.title}
                  width="50"
                  height={'50'}
                  objectFit="cover"
                  quality={50}
                  placeholder="blur"
                  blurDataURL={adObj.imageUrl || adObj['Image Url']}
                />
              </Box>

              <Link
                title={adObj.title}
                href="#"
                target="_blank"
                color="gray.dark"
                fontSize="13px"
                boxSizing="border-box"
                sx={{
                  textDecoration: 'none',
                  cursor: 'pointer',
                  alt: adObj.title,
                  ':hover': {
                    textDecoration: 'underline',
                    color: 'secondary.main',
                  },
                }}
              >
                {adObj.title}
              </Link>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LearnGrow;
